// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"259":"4c1d0f70","477":"3a40225f","902":"31420fc2"}[chunkId] + ".chunk.css";
};